import { useState } from 'react';

const FAQS = [
  {
    q: 'What is there to do in Highlands NC?',
    a: 'Highlands offers waterfalls, hiking trails, scenic drives, shopping, and dining, making it a popular mountain destination.',
  },
  {
    q: 'What are the best waterfalls in Highlands NC?',
    a: 'Popular waterfalls include Glen Falls, Dry Falls, and Bridal Veil Falls. All three are accessible from Highlands and vary in difficulty.',
  },
  {
    q: 'Is Highlands NC a good place to visit?',
    a: 'Highlands is known for its natural beauty, cool mountain climate, and relaxing atmosphere, making it a great place to visit year-round.',
  },
  {
    q: 'Where should I stay in Highlands NC?',
    a: 'Visitors can choose from cabins, vacation rentals, and other accommodations located near trails, waterfalls, and downtown Highlands.',
  },
  {
    q: 'When is the best time to visit Highlands NC?',
    a: 'Highlands is a year-round destination, with cool summers, fall foliage in October, spring waterfalls, and a quieter winter season.',
  },
  {
    q: 'Are there cabins near waterfalls in Highlands NC?',
    a: 'Yes, many cabins in Highlands NC are located near waterfalls and hiking trails, offering easy access to outdoor activities.',
  },
  {
    q: 'Is Highlands NC good for hiking?',
    a: 'Highlands is known for its hiking trails, including Whiteside Mountain, Glen Falls Trail, and other scenic routes in the area.',
  },
  {
    q: 'What are the best things to do in Highlands, NC?',
    a: 'Highlands, NC is known for its waterfalls, hiking trails, and scenic mountain views. Popular activities include visiting Glen Falls, exploring Dry Falls, hiking Whiteside Mountain, and enjoying the downtown area.',
  },
  {
    q: 'Is Glen Falls worth visiting in Highlands, NC?',
    a: 'Yes, Glen Falls is one of the most beautiful waterfalls in Highlands, NC. It features multiple cascades and a scenic hiking trail, making it a must-visit destination for visitors.',
  },
  {
    q: 'Where should I stay near Glen Falls in Highlands, NC?',
    a: 'Many visitors choose to stay near Glen Falls for convenience and scenery. Glen Falls Luxury Cabin in Highlands, NC is a popular option due to its location, privacy, and high guest ratings.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14" id="faq">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            FAQ
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-8 py-6 text-left cursor-pointer"
              >
                <span className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 transition-transform duration-300" style={{ transform: open === i ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                  <i className="ri-add-line text-[#2D4A3E] text-sm" />
                </div>
              </button>
              {open === i && (
                <div className="px-8 pb-7">
                  <div className="w-full h-px bg-[#F5F1EB] mb-5" />
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
